import * as React from 'react';
import * as moment from 'moment';
import { QuantitySelectProps } from '../../components/cart/quantity-select';

const QuantitySelectView: React.StatelessComponent<QuantitySelectProps> = props => {

    function onChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        const selectedValue = +evt.currentTarget.value;
        const priceTypeId = +evt.currentTarget.options[evt.currentTarget.selectedIndex].getAttribute('data-price-type');
        props.selectPriceTypeQuantity(priceTypeId, selectedValue);
    }

    const qtySelect = (
        <>
            {
                props.packagePriceTypes.map(pt => {
                    var selectName = "quantity" + pt.priceTypeId;

                    var options = Array.from(Array(pt.maxSeats + 1).keys());


                    return <div className={`stack-xs`} key={pt.priceTypeId}>
                        <label htmlFor={selectName}>{props.isVoucherPackage ? props.selectPackageTitle : props.selectTicketsText}</label>

                        <select name={selectName}
                            value={props.selectedPriceTypeQuantities.get(pt.priceTypeId) ? props.selectedPriceTypeQuantities.get(pt.priceTypeId) : 0} onChange={(evt) => {
                                onChange(evt);
                            }}>
                            {
                                options.map(quantity =>
                                    <option key={pt.priceTypeId + "-" + quantity} data-price-type={pt.priceTypeId} value={quantity} >{quantity}</option>
                                )}
                        </select>

                    </div>
                })
            }
        </>
    );

    const anyPerformances = Array.from(props.cartItems.keys()).length > 0;

    return (
        <>
            {
                props.isUnseatedReservation ?
                    <>
                        {anyPerformances ? 
                            <div className="stack-xs">
                                {qtySelect}
                            </div>
                            : null}
                    </>
                    :
                    <div className="stack">
                        { qtySelect }
                    </div>

            }
        </>
    );
}

export default QuantitySelectView;